import request from "@utils/request";

/**
 * 场景：后台管理页面---悦旅卡--卡种类--是否上架switch开关
 * @param data
 * @returns {*}
 */
export function saveOnshelf(data){
    return request.post("/eb/card/types/saveOnshelf",data);
}